module.exports = __webpack_public_path__ + "img/austria-external-causes-female.eb2651ba.png";